import React from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { InputCurrency, InputNumber } from '@goodfynd/react-web.lib.forms';

import { InputSwitch } from '../../../forms';
import { InputRadioChipGroup } from '../../../forms/InputRadioChipGroup';
import { EVENT_TYPES } from '../helpers';
import type { EventDetailsFormFields } from '../types';
const EventDetails = ({
  control,
  setValue,
}: UseFormReturn<EventDetailsFormFields>) => {
  return (
    <div>
      <InputNumber
        control={control}
        helperText="We recommend 1 vendor for per 100 guests and/or paying customers"
        label="Number of Vendors"
        name="numberOfVendors"
      />

      <InputCurrency control={control} label="Vending Fee" name="vendingFee" />

      <InputNumber
        control={control}
        label="Number of Guests/Units"
        name="numberOfGuest"
      />
      <InputRadioChipGroup
        control={control}
        label="Event Type"
        name="type"
        options={EVENT_TYPES}
      />

      <InputSwitch
        control={control}
        label="Rain or shine?"
        name="rainOrShine"
        setValue={setValue}
      />
    </div>
  );
};

export default EventDetails;
